module.exports = __webpack_public_path__ + "fonts/KaTeX_Math-Italic.8a5f936.ttf";